import { Membro } from "../../../model/Membro";
import Data from "./JSON/membrosDataPlaceholder.json";

const MembrosData: Membro[] = Data.map((MembroData) => {
  const Membro: Membro = {
    nome: MembroData.nome,
    cpf: MembroData.cpf,
    rg: MembroData.rg,
    orgao: MembroData.orgao,
    cargo: MembroData.cargo,
    email: MembroData.email,
    cep: MembroData.cep,
    estado: MembroData.estado,
    cidade: MembroData.cidade,
    bairro: MembroData.bairro,
    rua: MembroData.rua,
    complemento: MembroData.complemento,
  numero: 1, representante: false
  };
  return Membro;
});

export default MembrosData;
